import { createFileRoute } from "@tanstack/react-router"
import { CalendarPlus } from "lucide-react"

import { ScheduleDefinitionForm } from "@/components/guild-events-admin/schedule-definition-form"
import { PageIntroSplitHeader } from "@/components/layout/page-intro-split-header"
import { SectionKicker } from "@/components/shared/section-kicker"
import { Card } from "@/components/ui/card"

export const Route = createFileRoute(
  "/_authed/_admin/guild-events/schedules/new",
)({
  component: GuildEventScheduleCreateRoute,
})

function GuildEventScheduleCreateRoute() {
  return (
    <div className="grid gap-4 md:gap-5">
      <Card className="page-intro border-primary/10">
        <PageIntroSplitHeader
          kicker={
            <SectionKicker icon={<CalendarPlus />}>Guild events</SectionKicker>
          }
          title="Create recurring schedule"
          description="Define an event template, its recurring times, and where generated events should be delivered."
        />
      </Card>
      <ScheduleDefinitionForm />
    </div>
  )
}
